// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"dc8f87b7","453":"d95e8ac2","455":"676c6eba","977":"7190c189"}[chunkId] + ".chunk.js";
};